
export const CTV_CANNED_REPORTS: Array<any> = [
  {
    title: 'App Age',
    active: false,
    collapsed: false,
    reports: [
      {
        title: 'App Age < 3 Months',
        active: false,
        icon: '/assets/images/icon-report.svg',
        filters: {
          appAge: '[0,2]'
        },
        mainFilters: {
          region: 'GLOBAL'
        }
      },
      {
        title: 'App Age < 6 Months',
        active: false,
        icon: '/assets/images/icon-report.svg',
        filters: {
          appAge: '[0,5]'
        },
        mainFilters: {
          region: 'GLOBAL'
        }
      },
      {
        title: 'App Age < 12 Months',
        active: false,
        icon: '/assets/images/icon-report.svg',
        filters: {
          appAge: '[0,11]'
        },
        mainFilters: {
          region: 'GLOBAL'
        }
      }
    ]
  }
];
